import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// imported libraries
import { ToastrModule } from "ngx-toastr";
import { CookieService } from "ngx-cookie-service";

import { AppComponent } from "./app.component";
// other components
import { LoginComponent } from "./components/auth/login/login.component";
import { RegisterComponent } from "./components/auth/register/register.component";
import { ForgotpasswordComponent } from "./components/auth/forgotpassword/forgotpassword.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { AddItemComponent } from "./components/add-item/add-item.component";
import { ViewContentComponent } from "./components/view-content/view-content.component";
import { AddCatalogueComponent } from "./components/add-catalogue/add-catalogue.component";
import { ItemsSelectionViewComponent } from "./components/items-selection-view/items-selection-view.component";
// import { DashboardComponent } from './components/dashboard/dashboard.component';

// pipes
import { FilterPipePipe } from "./pipes/filter-pipe.pipe";
import { SettingsComponent } from "./components/settings/settings.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ForgotpasswordComponent,
    PageNotFoundComponent,
    AddItemComponent,
    ViewContentComponent,
    AddCatalogueComponent,
    ItemsSelectionViewComponent,
    FilterPipePipe,
    SettingsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: "toast-top-right",
      preventDuplicates: false
    }),
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule {}
